import { makeRetriableGetRequest, makeApiGetRequest } from '../api/apiActions';

class AMAServiceClient {
    static URL = '/lantern-ama';

    /**
     * Constructs request url to Lantern AMA service for playlist endpoint.
     */
    static constructPlaylistEndpoint(studentId) {
        return `${AMAServiceClient.URL}/playlist?student_uids=${studentId}`;
    }

    /**
     * Constructs request url to Lantern AMA service for next form id endpoint.
     */
    static constructNextFormEndpoint({ studentId, measure, period, secure }) {
        const params = [];
        let endpoint = `${AMAServiceClient.URL}/next_form_id`;
        if (studentId) {
            params.push(`student_uid=${studentId}`);
        }
        if (period) {
            params.push(`period=${period}`);
        }
        if (measure) {
            params.push(`measure=${measure}`);
        }
        if (secure) {
            params.push(`secure=${secure}`);
        }
        if (params.length > 0) {
            endpoint += `?${params.join('&')}`;
        }
        return endpoint;
    }

    /**
     * Sends GET request for playlist endpoint.
     * @param {str} studentId student to get playlist for
     */
    static getPlaylist = (studentId) => (dispatch) => {
        const endpoint = AMAServiceClient.constructPlaylistEndpoint(studentId);
        return dispatch(makeApiGetRequest(endpoint));
    };

    /**
     * Sends GET request for next_form_id endpoint and allows to retry it.
     * @param {str} studentId student to get next form for
     * @param {str} period BOY|MOY|EOY|SUMMER|PM
     * @param {str} measure observational measure: DAZE|DORF|TRC
     * @param secure
     * @param retryActionName
     */
    static getNextFormId = (studentId, period, measure, secure, retryActionName) => (dispatch) => {
        const config = {
            studentId,
            period,
            measure,
            secure
        };
        const endpoint = AMAServiceClient.constructNextFormEndpoint(config);
        return dispatch(makeRetriableGetRequest(endpoint, retryActionName));
    };
}

export default AMAServiceClient;
